export default {"src":"/_next/static/image/public/images/ic_rx_prescription.ffe05eafd71adde50e28ef6ceece414d.svg","height":36,"width":36};